module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_05_beach-photo-0285449951f6564353f2c9a96bf783cf.jpg";